import { enqueueSnackbar } from "notistack";
import {
  CertBottomButton,
  CertBottomInfo,
  CertInputWrapper,
  CertTitle,
  CertWrapper,
} from "./styles/cert";
import { isApp } from "../../../hooks/useNativeApp";
import { insetState } from "../../../recoil/inset";
import { useRecoilValue } from "recoil";

interface StepProps {
  certPhone: string;
  setCertPhone: (phone: string) => void;
  onNext: () => void;
}

const StepCertPhone = ({ certPhone, setCertPhone, onNext }: StepProps) => {
  const inset = useRecoilValue(insetState);
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (/^[\d+]*$/.test(value)) {
      setCertPhone(value);
    }
  };

  const handleNext = () => {
    if (certPhone.length === 0) {
      enqueueSnackbar("전화번호를 입력해 주세요.", { variant: "error" });
      return;
    }

    onNext();
  };

  return (
    <CertWrapper isApp={inset}>
      <CertTitle>전화번호를 입력해 주세요.</CertTitle>
      <CertInputWrapper>
        <input
          type="text"
          value={certPhone}
          onChange={handleInputChange}
          placeholder="전화번호를 입력해주세요.(예: 01012345678)"
        />
      </CertInputWrapper>
      <CertBottomButton onClick={handleNext}>다음</CertBottomButton>
      <CertBottomInfo>
        PASS 인증을 하지 않은 계정의 경우, 매장 이용 시 본인 확인
        <br /> (신분증, 여권 등) 정보와 일치하지 않으면 매장 이용이
        불가능합니다.
      </CertBottomInfo>
    </CertWrapper>
  );
};

export default StepCertPhone;
